import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import PayslipModal from "../components/modal/EmployeePaySlip";
import PaginatedTable from "../components/library/Pagination";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Loader from "../components/common/Loader";
import { Form, Spinner } from "react-bootstrap"
import API_BASE_URL from "../config/api";

const PayrollPage = () => {

    const [payrollData, setPayrollData] = useState([]);
    const [year, setYear] = useState("");

    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [yearList, setYearList] = useState([]);
    const [download, setDownload] = useState(false);
    const employeeId = sessionStorage.getItem("employeeId");
    const [selectedIds, setSelectedIds] = useState([]);
    const hiddenPayslipsRef = useRef();
    const [shouldDownload, setShouldDownload] = useState(false);
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);

    const token = sessionStorage.getItem("token"); // assumed

    const fetchOption = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/Config/children/12`);

            const minYearStr = Array.isArray(res.data) && res.data.length > 0 ? res.data[0].value : null;
            const minYear = parseInt(minYearStr, 10);
            const currentYear = new Date().getFullYear();

            if (!isNaN(minYear)) {
                const years = [];
                for (let y = currentYear; y >= minYear; y--) {
                    years.push(y.toString());
                }
                setYearList(years);
            } else {
                setYearList([]);
            }
        } catch (error) {
            console.error("Error fetching year list:", error);
            setYearList([]);
        }
    };


    const fetchPayroll = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${API_BASE_URL}/api/payroll/EmployeePayrollData?id=${employeeId}&year=${year}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setPayrollData(Array.isArray(response.data?.result) ? response.data.result : []);


        } catch (err) {
            console.error("Failed to fetch payroll:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOption();
    }, []);


    const openPayslip = (employee) => {
        setSelectedEmployee(employee);
        setIsModalOpen(true);
    };

    const closePayslip = () => {
        setIsModalOpen(false);
        setSelectedEmployee(null);
    };

    // Toggle checkbox
    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    // Select all
    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedIds(payrollData.map((item) => item.id));
        } else {
            setSelectedIds([]);
        }
    };


    const handleDownloadSelected = async () => {

        if (selectedIds.length === 0) {
            setNotification({ type: "error", message: `Please select at least one payslip to download.` });
            return;
        }
        setDownload(true);
        setTimeout(() => {
            setDownload(false);
        }, 2000);

    };

    const closeNotification = () => setNotification(null);

    return (
        <>
            {loading ? (
                <Loader message="Loading..." />
            ) : (
                <div className="py-5">
                    <div>
                        <div className="mb-6">
                            <h1 className="text-3xl font-bold text-[#121516]">Payroll</h1>
                        </div>
                        {notification && (
                            <div
                                className={`mb-4 p-4 rounded ${notification.type === "error"
                                    ? "bg-red-100 text-red-700"
                                    : "bg-green-100 text-green-700"
                                    }`}
                            >
                                <div className="flex justify-between items-center">
                                    <span>{notification.message}</span>
                                    <button onClick={closeNotification} className="font-bold text-xl leading-none">
                                        ×
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Filters */}
                        <div className="flex gap-4 mb-4 flex-wrap items-end">
                            <div>
                                <label className="block text-sm font-medium">Year</label>
                                <select
                                    className="w-40 h-12 border rounded-xl p-2"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                >
                                    <option value="">Select Year</option>
                                    {Array.isArray(yearList) &&
                                        yearList.map((y) => (
                                            <option key={y} value={y}>
                                                {y}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <button
                                onClick={fetchPayroll}
                                className="custom-btn mb-2"
                            >
                                Apply Filter
                            </button>
                            <button
                                className="btn-black mb-2"
                                onClick={handleDownloadSelected}
                            >
                                {
                                    download ?
                                        <><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} /> Downloading...</>
                                        :
                                        'Download Payslip'
                                }

                            </button>
                        </div>

                        {/* Payroll Table */}
                        <div className="overflow-auto border rounded-xl">

                            <PaginatedTable
                                columns={[
                                    <input
                                        type="checkbox"
                                        checked={selectedIds.length === payrollData.length && payrollData.length > 0}
                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                    />,
                                    "Month",
                                    "BasicPay",
                                    "Allowances",
                                    "Deductions",
                                    "Net Salary",
                                    "Status",
                                    "Generated On",
                                    "Payslip",
                                ]}
                                data={payrollData}
                                pageSize={10}
                                renderRow={(item) => (
                                    <tr key={item.employeeId} className="border-t">
                                        <td className="px-4 py-3">
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.includes(item.id)}
                                                onChange={() => handleCheckboxChange(item.id)}
                                            />
                                        </td>
                                        <td className="px-4 py-3">{new Date(2000, item.month - 1, 1).toLocaleString("default", { month: "long" })}</td>
                                        <td className="px-4 py-3">₹{Number(item.basicPay || 0).toLocaleString("en-US")}</td>
                                        <td className="px-4 py-3">₹{Number(item.allowances || 0).toLocaleString("en-US")}</td>
                                        <td className="px-4 py-3">₹{Number(item.deductions || 0).toLocaleString("en-US")}</td>
                                        <td className="px-4 py-3">₹{Number(item.netSalary || 0).toLocaleString("en-US")}</td>
                                        <td className="px-4 py-3">
                                            <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
                                                {item.status}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3">
                                            {new Date(item.createdOn).toLocaleDateString("en-GB")}
                                        </td>
                                        <td className="px-4 py-3">
                                            <button
                                                className="flex min-w-[80px] max-w-[80px] cursor-pointer items-center justify-center hover:bg-black hover:text-white overflow-hidden rounded-full h-8 px-4 bg-[#f1f3f4] text-[#121516] text-sm font-medium leading-normal w-full"
                                                onClick={() => openPayslip(item)}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                )}
                            />

                        </div>
                        {isModalOpen && selectedEmployee && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-auto relative">
                                    <button
                                        className="absolute top-2 right-4 text-gray-500 hover:text-gray-800"
                                        onClick={closePayslip}
                                    >
                                        ✕
                                    </button>
                                    <PayslipModal
                                        employeeId={selectedEmployee.employeeId}
                                        id={selectedEmployee.id}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div
                        ref={hiddenPayslipsRef}
                        style={{
                            position: "absolute",
                            top: "-9999px",
                            left: "-9999px",
                            visibility: "visible",   // must be visible
                            width: "800px"           // match your payslip width
                        }}
                    >
                        {download && selectedIds.map((id) => {
                            const emp = payrollData.find((x) => x.id === id);
                            if (!emp) return null;
                            return (
                                <div key={id} id={`payslip-${id}`} style={{ marginBottom: "20px" }}>
                                    <PayslipModal employeeId={emp.employeeId} id={emp.id} download={true} />
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default PayrollPage;
